<template>
  <div class="custom-card" :class="{ navigating: isNavigating }">
    <div class="custom-card-content" @click="handleChatNow(info)">
      <div
        class="custom-card-content-img overflow-hidden"
        :style="{
          aspectRatio: isCardRatio ? getCardRatio(info?.id || info?.roleId) : '3/4'
        }"
      >
        <AppImage
          :src="info.background || info?.roleInfo?.background"
          alt="avatar"
          width="100%"
          height="100%"
          :show-loading="true"
          :show-error="true"
          :lazy-load="false"
          :custom-loading="true"
          :srcGif="info.backgroundGif"
          :custom-error="true"
          fallback="@/assets/images/home/sitemap.webp"
          fit="cover"
        />
        <div class="custom-card-content-info absolute top-5px right-5px flex" v-if="false">
          <div class="w-10px h-10px flex items-center justify-center">
            <img src="@/assets/images/home/message_num.svg" class="w-full h-full" />
          </div>
          <!-- <div v-if="info.chatCount === 0 || info.chatCount">{{ ((info.chatCount / 1000)).toFixed(2) || 0.00
                        }}K
                    </div>
                    <div v-else>{{ ((info?.roleInfo?.chatCount) / 1000).toFixed(2) || 0.00 }}K</div> -->
        </div>
        <div class="absolute bottom-0 left-0 z-1 cover-bg"></div>
        <div class="custom-card-content-info-text-box">
          <div v-if="info.isVip">
            <img src="@/assets/images/home/icon-vip.svg" alt="" class="w-100% h-100%" />
          </div>
          <div
            class="text-10px color-#fff font-500 box flex items-center justify-center h-20px lh-20px"
            v-if="info.isCalcHot"
          >
            <div class="flex items-center justify-center">
              <div class="w-8px h-10px flex items-center justify-center">
                <img src="@/assets/images/home/hot.svg" alt="" class="w-100% h-100%" />
              </div>
            </div>
            <div class="ml-2px">Hot</div>
          </div>
          <div
            class="text-10px color-#fff font-500 box flex items-center justify-center h-20px lh-20px"
            v-else-if="info.isCalcNew"
          >
            <div class="flex items-center justify-center">
              <div class="w-10px h-10px flex items-center justify-center">
                <img src="@/assets/images/home/new.svg" alt="" class="w-100% h-100%" />
              </div>
            </div>
            <div class="ml-2px">New</div>
          </div>
        </div>
        <div
          class="custom-card-content-info-text color-#fff text-ellipsis overflow-hidden max-w-100px"
        >
          {{ info.name }}
        </div>
        <div
          class="custom-card-content-info-text-2 flex items-center justify-center"
          v-if="info?.chatCount > 0"
        >
          <div class="w-12px! h-12px flex items-center justify-center">
            <img src="@/assets/images/home/message.webp" alt="" class="w-100% h-100%" />
          </div>
          <div class="text-9px color-#fff ml-4px">
            {{
              info?.chatCount > 1000 ? (info?.chatCount / 1000).toFixed(2) + 'k' : info?.chatCount
            }}
          </div>
        </div>
        <div class="custom-card-content-info-text-3" v-if="isFree(info?.pid)">Free</div>
      </div>
      <div class="custom-card-info">
        <div class="hover-description">
          {{
            info?.descriptionNew ||
            info?.roleInfo?.descriptionNew ||
            'No Intro yet. Chat and find out by yourself.'
          }}
        </div>
        <!-- <div class="custom-card-tags-item" v-if="isShowTags">
                    <div class="custom-card-tags-item-text"
                        v-for="(value, index) in (info.tags || info?.roleInfo?.tags || []).slice(0, 2)" :key="index">
                        {{ value }}
                    </div>
                </div> -->
      </div>
      <div class="h-5px"></div>
    </div>
  </div>
</template>

<script setup>
import { logEventSafe } from '@/plugins/firebase'
import AppImage from '@/components/display/AppImage.vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import { ref } from 'vue'
import theme from '@/styles/theme'
import { userStorage } from '@/utils/storage'
import { useWaterfallStore } from '@/stores/waterfall'
import { useUserStore } from '@/stores/user'
const router = useRouter()
const { t } = useI18n()
const waterfallStore = useWaterfallStore()
const route = useRoute()
// 防止重复点击
const isNavigating = ref(false)
const hasPrefetchedChat = ref(false)
const emit = defineEmits(['open-preview'])
const userStore = useUserStore()

const isFree = id => {
  return userStore.getIsFree().includes(id)
}
const props = defineProps({
  currentTabId: {
    type: Number,
    default: 0
  },
  info: {
    type: Object,
    default: () => ({})
  },
  isShowTags: {
    type: Boolean,
    default: true
  },
  gap: {
    type: Number,
    default: 24
  },
  isLike: {
    type: Boolean,
    default: false
  },
  isCardRatio: {
    type: Boolean,
    default: true
  }
})
// const seed = Number(String(id).slice(-2))
const ratioList = [
  { ratio: '3/4', weight: 50 },
  { ratio: '2/3', weight: 30 },
  { ratio: '9/16', weight: 20 }
]

const getCardRatio = id => {
  const str = String(id)

  let hash = 0

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }

  const seed = Math.abs(hash % 100)

  if (seed < 70) return '3 / 4'
  if (seed < 90) return '2 / 3'

  return '9 / 16'
}
// 点击数字人卡片跳转埋点
const sendMessageLogEvent = () => {
  switch (waterfallStore.activeTab) {
    case 2:
      logEventSafe('hotlist_photo_click')
      break
    case 9:
      logEventSafe('popularlist_photo_click')
      break
    case 3:
      logEventSafe('newlist_photo_click')
      break
    case 4:
      logEventSafe('femalelist_photo_click')
      break
    default:
      break
  }
}

// 跳转聊天
const handleChatNow = async info => {
  if (isFree(info.pid)) {
    logEventSafe('free_click')
  }

  // if (info.isVip) {
  //     const userStore = useUserStore()
  //     if (![3, 4, 5].includes(userStore.userInfo?.role)) {
  //         emit('open-preview', info)
  //         return
  //     }
  // }

  sendMessageLogEvent()

  try {
    // 预取 Chat 页面资源，尽量减少首跳耗时
    // isNavigating.value = true
    const preData = {
      name: info.name,
      avatar: info.avatar,
      background: info.background || info?.roleInfo?.backgroundThumb,
      id: info.roleId || info.id,
      creatorNotes: info.creatorNotes
    }

    if (isFree(info.pid)) {
      router.push({
        path: '/chat',
        query: {
          preData: encodeURIComponent(JSON.stringify(preData)),
          route: route.path,
          isFree: 'true'
        }
      })
    } else {
      router.push({
        path: '/chat',
        query: { preData: encodeURIComponent(JSON.stringify(preData)), route: route.path }
      })
    }
    // 2. 立即跳转，不等待 Promise 以获得更快的响应

    if (route.path === '/') {
      logEventSafe('home_click_chat_up')
    }
  } catch (error) {
    console.error('跳转失败:', error)
    // 即使出错也要跳转
    router.push({ path: '/chat' })
  } finally {
    // 重置状态 (延迟一点防止误触)
    // setTimeout(() => {
    //     isNavigating.value = false
    // }, 500)
  }
}

// 预加载 Chat 视图，缓解首跳白屏/卡顿
const prefetchChatView = () => {
  if (hasPrefetchedChat.value) return
  hasPrefetchedChat.value = true
  import('@/views/message/chat.vue')
}
</script>
<style lang="scss" scoped>
.custom-card {
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  // 🚀 GPU加速
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;

  // 点击反馈
  &.navigating {
    opacity: 0.7;
    transform: scale(0.98) translateZ(0);
    pointer-events: none;
  }

  // 悬停效果（使用transform优化）
  &:hover:not(.navigating) {
    transform: translateY(-2px) translateZ(0);
  }

  // 点击效果（使用transform优化）
  &:active:not(.navigating) {
    transform: scale(0.98) translateZ(0);
  }

  .custom-card-content-info-text-box {
    position: absolute;
    top: 8px;
    left: 8px;
    border-radius: 3px;

    display: flex;
    align-items: center;
    gap: 4px;

    .box {
      background: rgba(0, 0, 0, 0.5);
      border-radius: 3px;
      padding: 0px 4px;
    }
  }

  .custom-card-content {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;

    .custom-card-content-img {
      transition: transform 0.3s ease;
      position: relative;
      border: 3px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
      }
    }

    .custom-card-content-info {
      background-color: v-bind('theme.colors.backgroundTertiary');
      border-radius: 12px;
      padding: 6px 6px;
      align-items: center;
      justify-content: space-between;
      // z-index: 2;
      width: 60px;
      height: 20px;
      border-radius: 10px;
      font-weight: 800;
      font-size: 10px;
      color: #ffffff;
    }

    .custom-card-content-info-text {
      font-weight: 600;
      font-size: 13px;
      color: #ffffff;
      line-height: 19px;
      position: absolute;
      bottom: 8px;
      left: 5px;
      z-index: 1;
    }
  }
}

.custom-card-info {
  .hover-description {
    margin-top: 8px;
    // margin-bottom: 4px;
    padding: 0 3px;
    color: v-bind('theme.colors.textPrimary');
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
    max-height: calc(1.4em * 3);
    font-weight: 500;
    font-size: 11px;
  }

  .custom-card-tags-item {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;

    .custom-card-tags-item-text {
      background-color: v-bind('theme.colors.backgroundSecondary');
      margin-right: 4px;
      margin-bottom: 4px;
      border-radius: 13px;
      padding: 2px 8px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      opacity: 0.7;
      font-weight: 500;
      font-size: 10px;
      // color: #999;
    }
  }
}

.custom-card-content-info-text-2 {
  // background: linear-gradient(180deg, rgba(1, 3, 27, 0) 0%, #01031B 100%);
  // background: linear-gradient(180deg, rgba(1, 3, 27, 0) 0%, rgba(1, 3, 27, 0.7) 100%);
  // border-radius: 0px 0px 10px 10px;
  // height: 50px;
  position: absolute;
  // background: rgba(255, 255, 255, 0.1);
  // backdrop-filter: blur(10px);
  bottom: 10px;
  right: 4px;
  z-index: 2;
  // width: 100%;
  // z-index: 0;
  border-radius: 50%;
}

.custom-card-content-info-text-3 {
  padding: 0 8px;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
  background-color: #fff;
  position: absolute;
  top: 0px;
  left: 10px;
  z-index: 1;
  border-radius: 0 0 5px 5px;
}

.gap-24px {
  margin-bottom: 24px;
}

.gap-48px {
  margin-bottom: 48px;
}

.cover-bg {
  width: 100%;
  height: 80px;
  background: linear-gradient(180deg, rgba(1, 3, 27, 0) 0%, rgba(1, 3, 27, 0.7) 100%);
  // border-radius: 0px 0px 10px 10px;
}
</style>
